import { render, staticRenderFns } from "./SearchClient.vue?vue&type=template&id=7dc74e10"
import script from "./SearchClient.vue?vue&type=script&lang=ts"
export * from "./SearchClient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports